/* Add mousover action to main navbar dropdown */
jQuery  (
        function()
            {   
            /*             
            $(".btn-spinner").on    (
                                    'click',
                                    function(e)
                                        {
                                        //e.preventDefault();

                                        // disable button
                                        $(this).prop("disabled", true);

                                        // show spinner on button
                                        $(this).find('.btn-spinner-container').removeClass('d-none');
                                        $(this).find('.btn-spinner-label').addClass('d-none');
                                        }
                                    );
            */


                                    
            function myToggleDropdown(e)
                {
                const dropDown = $(e.target).closest('.dropdown'),
                dropDownMenu = $('.dropdown-menu', dropDown);

                setTimeout  (
                            function()
                                {
                                const shouldOpen = e.type !== 'click' && dropDown.is(':hover');

                                dropDown.toggleClass('show', shouldOpen);
                                dropDownMenu.toggleClass('show', shouldOpen);

                                $('[data-toggle="dropdown"]', dropDown).attr('aria-expanded', shouldOpen);
                                },

                            e.type === 'mouseleave' ? 100 : 0
                            );
                }



            $('body')   .on('mouseenter mouseleave','.navbar-lower .dropdown', myToggleDropdown);
                        //.on('click', '.navbar-lower .dropdown-menu a', myToggleDropdown);



            /* Add auto collapse to bootstrap collapse */
            /*
            $('.collapse.auto-collapse')    .off()
                                            .on (
                                                'hidden.bs.collapse',
                                                function(e)
                                                    {
                                                    if( $(this).is(e.target) )
                                                        {
                                                        var selector = $(this).closest('li').find('.collapse.show');                                                        
                                                        selector.removeClass('show');                                                       
                                                        }
                                                    }
                                                );
            */                          
            }
        );